import { FunctionCloneDeep } from "radium-omnibus";
import * as React from "react";
import { focusAndOpenKeyboard } from "../../utils/useFunction";

const TEXT_AUTHOR = "radium-omnibus";
const TYPE_FUNCTION = "function";

const FieldOTP = ({ props }) => {
  const createArray = new Array(props.count).fill("");
  const [thisValue, setThisValue] = React.useState(createArray);
  const [currentIndex, setCurrentIndex] = React.useState(0);
  const [loaded, setLoaded] = React.useState(false);

  React.useEffect(() => {
    if (window !== undefined) {
      // props.otpReference.current[currentIndex]?.focus();

      // setTimeout(() => {
      // props.otpReference.current[currentIndex]?.blur();
      props.otpReference.current[currentIndex]?.focus();
      // focusAndOpenKeyboard(props.otpReference.current[currentIndex]);
      // }, 100);

      if (currentIndex === props.count && thisValue[props.count - 1] !== "") {
        const result = thisValue.join("");

        props.setValue(result);
        props.trigger(result);
      } else {
        return;
      }
    } else {
      return;
    }
  }, [currentIndex, props.otpReference.current]);

  React.useEffect(() => {
    if (loaded === false) {
      props.otpReference.current = [];
      setLoaded(true);
    }
  }, [props.otpReference]);

  React.useEffect(() => {
    if (window) {
      window?.addEventListener("paste", (event) => {
        const paste = (event?.clipboardData || window?.clipboardData).getData(
          "text"
        );

        if (paste.length === props.count) {
          props.setValue(paste);
          props.trigger(paste);
          setThisValue(paste.split(""));
        }
      });
    }
  }, []);

  React.useEffect(() => {
    if (props?.value?.length === props?.count) {
      FunctionTrigger();
    }
  }, [props?.value]);

  const FunctionTrigger = async () => {
    const clone = FunctionCloneDeep(props?.value);
    await props.trigger(clone);
  };

  if (loaded) {
    return (
      <React.Fragment>
        {createArray?.map((_, i) => {
          const none = thisValue[i - 1] === "" && i !== 0;
          const hasLength = thisValue[i]?.length > 0 && i !== props.count - 1;
          return (
            <input
              type="number"
              className={`${TEXT_AUTHOR}-input ${
                typeof props.classNameInput === TYPE_FUNCTION
                  ? props.classNameInput({ ...props, inputIndex: i })
                  : props.classNameInputf
              }`}
              ref={(ref) => {
                props.otpReference.current[i] = ref;
              }}
              key={i}
              id={`otp-index-${i}`}
              pattern="[0-9]*"
              onKeyUp={(e) => {
                const isDelete = e.key === "Backspace";

                if (isDelete) {
                  setThisValue((prev) => {
                    const newValue = [...prev];
                    newValue[i - 1] = "";
                    return newValue;
                  });

                  props.otpReference.current[i - 1].value = "";

                  setCurrentIndex(i - 1);
                }
              }}
              // value={thisValue[i]}
              // disabled={none || hasLength}
              onClick={(e) => {
                if (none || hasLength) {
                  // props.otpReference.current[i].blur();
                  props.otpReference.current[currentIndex]?.focus();
                }
              }}
              onChange={(e) => {
                const value = e.target.value;

                if (value?.length <= 1) {
                  setThisValue((prev) => {
                    const newValue = [...prev];
                    newValue[i] = value;
                    return [...newValue];
                  });
                  if (currentIndex < props.count) {
                    setCurrentIndex(i + 1);
                  } else {
                    return;
                  }
                } else if (value?.length === props?.count) {
                  value.split("").map((_, i) => {
                    props.otpReference.current[i].value = value[i];
                  });
                  props.setValue(value);
                } else {
                  return;
                }
              }}
            />
          );
        })}
      </React.Fragment>
    );
  } else {
    return <React.Fragment />;
  }
};

export default FieldOTP;
